/* Re-use the two numbers check for coordinates. Makes the code more readable. */
import twoNumbers from './twoNumbers';

const coord = twoNumbers;

export default coord;



// WEBPACK FOOTER //
// ./src/propTypes/coord.js